import { createAccountTemplate, createAccount } from "./createAccount";
	import { deployContractTemplate, deployContract } from "./deployContract";
	import { initManagerTemplate, initManager } from "./initManager";
	import { mintTokensTemplate, mintTokens } from "./mintTokens";
	import { registerContractTemplate, registerContract } from "./registerContract";
	import { scratchTemplate, scratch } from "./scratch";
	import { setBlockOffsetTemplate, setBlockOffset } from "./setBlockOffset";
	import { setTimestampOffsetTemplate, setTimestampOffset } from "./setTimestampOffset";
	import { updateContractTemplate, updateContract } from "./updateContract";
	export {
	  createAccountTemplate,
	  createAccount,
	  deployContractTemplate,
	  deployContract,
	  initManagerTemplate,
	  initManager,
	  mintTokensTemplate,
	  mintTokens,
	  registerContractTemplate,
	  registerContract,
	  scratchTemplate,
	  scratch,
	  setBlockOffsetTemplate,
	  setBlockOffset,
	  setTimestampOffsetTemplate,
	  setTimestampOffset,
	  updateContractTemplate,
	  updateContract,
	};
	export default {
	  createAccountTemplate,
	  createAccount,
	  deployContractTemplate,
	  deployContract,
	  initManagerTemplate,
	  initManager,
	  mintTokensTemplate,
	  mintTokens,
	  registerContractTemplate,
	  registerContract,
	  scratchTemplate,
	  scratch,
	  setBlockOffsetTemplate,
	  setBlockOffset,
	  setTimestampOffsetTemplate,
	  setTimestampOffset,
	  updateContractTemplate,
	  updateContract,
	};
	